<template>
  <router-link :to="{ name: 'financial-targets.show', params: { financial_target_id: financialTarget.id } }">
    <div class="row">
      <div class="col-12 col-lg-6">
        <p class="text-truncate">
          <span class="strong">
            {{ financialTarget.financial_year_start | moment('DD/MM/YYYY') }} - {{ financialTarget.financial_year_end | moment('DD/MM/YYYY') }}
          </span>
        </p>
      </div>
      <div class="col-4 col-lg-2">
        <p>
          <span class="data-label d-lg-none">Revenue:</span>
          ${{ financialTarget.revenue | currency }}
        </p>
      </div>
      <div class="col-4 col-lg-2">
        <p>
          <span class="data-label d-lg-none">Profit:</span>
          ${{ financialTarget.profit | currency }}
        </p>
      </div>
      <div class="col-4 col-lg-2 text-end">
        <p>
          <span class="data-label d-lg-none">Sales:</span>
          ${{ financialTarget.sales | currency }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    financialTarget: {
      required: true,
      type: Object
    }
  }
}
</script>
